import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {Button, Card, Select, SelectProps, Table, Tag, Popconfirm} from "antd";
import Colors from "../../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash, BiUndo } from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye, BsReceipt, BsFilePdf} from "react-icons/bs";
import {GetPropostaPdf} from "../../../dao/menudesign/comandes/GetPropostaPdf";
import PopostesModal from "../comandes/PropostesModal"
import {GetPropostes} from "../../../dao/menudesign/comandes/GetPropostes";
import Proposta from "../../../model/menudesign/comandes/Proposta";
import {format} from "date-fns";
import toast, {Toaster} from "react-hot-toast";
import { PutProposta } from '../../../dao/menudesign/comandes/PutProposta';
import { color } from 'html2canvas/dist/types/css/types/color';
import { DeleteComandaIngredients } from '../../../dao/menudesign/comandes/DeleteComandaIngredient';
import {QuestionCircleOutlined} from "@ant-design/icons";
import ComandaFinalizadaModal from './ComandaFinalizadaModal';

const Propostes = () => {
    const titol: string = "Comandes";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Proposta[]>([]);
    const [elementSelected, setElementSelected] = useState<Proposta>(new Proposta());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouElementFinalizat, setNouElementFinalizat] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);
    const [editar, setEditar] = useState(false);
    // Filtre opcional per setmana (format "YYYY-Www", com l'input type="week").
    const [setmana, setSetmana] = useState<string>("");

    const permisEditarProposta = user.pagines.find(pagina => pagina.descripcio === "Proposta Comanda" && pagina.tipus === 1);
    const permisEditarComanda = user.pagines.find(pagina => pagina.descripcio === "Comanda Final" && pagina.tipus === 1);

    const [options, setOptions] = useState(
        [
            {label: 'pendents', value: 0},
            {label: 'enviades', value: 1},
            {label: 'revisades', value: 2},
            {label: 'finalitzades', value: 3}
        ]
    );
    const [filtres, setFiltres] = useState<number[]>([]);


    useEffect(() => {
        if(isLoggedIn){
            const filtresInicials = permisEditarComanda ? [0,1,2] : [0];
            setFiltres(filtresInicials);
            handleLoadingChange(true);
            checkDades(filtresInicials);
        }

    }, [id, isLoggedIn, !!permisEditarComanda]);

    async function checkDades(filtre: number[]) {
        handleLoadingChange(true)
        const fil = filtre.join('-');
        // Gestor (permisEditarComanda) veu totes → id_usu=0
        // Escola (sense permisEditarComanda) veu només les seves → id_usu=userId
        const idUsu = permisEditarComanda ? 0 : Number(userId);
        console.log('[Propostes] checkDades → filtres:', fil, '| idUsu:', idUsu, '| page:', page, '| permisEditarComanda:', !!permisEditarComanda, '| userId:', userId);
        const dades = await GetPropostes(page, fil, idUsu);
        console.log('[Propostes] resposta GetPropostes:', dades);
        const dadesArray = Array.isArray(dades) ? dades : [];
        setDades(dadesArray);
        setNameFilters(dadesArray);
        handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(proposta: Proposta) {
        const propostaEliminada = { ...proposta, estat: -1 }; // estado -1
        await PutProposta(page, propostaEliminada, userId);
        await checkDades(filtres);
    }
    async function revertirElement(proposta: Proposta) {
        await DeleteComandaIngredients( proposta.id, page, userId);
        toast.success("REVERTIT");
        await checkDades(filtres);
    }

    async function descarregarPdf(proposta: Proposta) {
        const url = await GetPropostaPdf(proposta.id, page);
        if (url && url !== "") {
            const link = document.createElement('a');
            link.href = url;
            link.download = `proposta_${proposta.id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }


    function afegirElement(element: Proposta) {
        setEditar(true);
        setNouElement(!nouElement);
        setElementSelected(element);
        
    }

    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        
        checkDades(filtres);

    }
    function handleCloseModalFinalizat() {
        
        setNouElementFinalizat(false);
        checkDades(filtres);

    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Proposta[]) {
        if (elements?.length > 0) {
            const uniqueNonEmptyNames = Array.from(new Set(elements
                .map((element) => element.escola)
                .filter((name) => name !== '')));

            const ingredientNames = uniqueNonEmptyNames.map((name) => ({
                text: name,
                value: name,
            }));

            setNomFiltres(ingredientNames);
        }
    }

    

    function togleEditar(id : number, viewOnly = false) {
        navigate(`/menudesign/propostes/${id}?view=${viewOnly ? "true" : "false"}`);
    }

    function togleVeuComandaFinalizada(proposta: Proposta) {
        setEditar(true);
        setNouElementFinalizat(!nouElementFinalizat);
        setElementSelected(proposta);
    }

    const columns: ColumnsType<Proposta> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                ele.estat === 0 ? <Tag color={"orange"}>Pendent</Tag> :
                    ele.estat === 1 ? <Tag color={"blue"}>Enviat</Tag> :
                        ele.estat === 2 ? <Tag color={"cyan"}>Revisat</Tag> :
                            <Tag color={"green"}>Finalitzat</Tag>
            )
        },
        {
            key: 'creacio',
            title: 'Data de Creació',
            dataIndex: 'creacio',
            width: 10,
            render: (estat, ele) => (
                <Tag color={"green"}>{format(new Date(ele.creacio), 'dd-MM-yyyy')}</Tag>
            )
        },
        {
            key: 'escola',
            title: 'Escola',
            dataIndex: 'escola',
            width: 100,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.escola.startsWith(value) : false),
        },
        {
            key: 'inici',
            title: "Data d'inici",
            dataIndex: 'inici',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                <Tag>{format(new Date(ele.inici), 'dd-MM-yyyy')}</Tag>
            )
        },
        {
            key: 'fin',
            title: 'Data final',
            dataIndex: 'fin',
            width: 10,
            responsive: ['lg'],
            render: (estat, ele) => (
                <Tag>{format(new Date(ele.fin), 'dd-MM-yyyy')}</Tag>
            )
        },
        
        {
            key: 'accions',
            title: 'Accions',
            dataIndex: 'accions',
            width: permisEditarProposta || permisEditarComanda ? 180 : 120,
            render: (estat, ele) => {
                const esProposta = permisEditarProposta && ele.estat === 0;
                const esComandaEditable = permisEditarComanda && [1, 2].includes(ele.estat);
                const esComandaFinalitzada = permisEditarComanda && ele.estat === 3;

                const potEditar =
                esProposta || esComandaEditable;
                const potEliminar =
                esProposta || esComandaEditable;
                const potVeure =
                !permisEditarProposta && !permisEditarComanda
                    ? [0, 1, 2].includes(ele.estat)
                    : ele.estat === 0 ||
                    [1, 2].includes(ele.estat) ||
                    ele.estat === 3;

                return (
                <>
                    {/* EDITAR */}
                    {potEditar && (
                    <Button
                        title="Editar"
                        style={{ backgroundColor: Colors.colors.color6 }}
                        onClick={() => togleEditar(ele.id)}
                    >
                        <BiPencil />
                    </Button>
                    )}{" "}

                    {/* ELIMINAR */}
                    {potEliminar && (
                    <Popconfirm
                                title="Eliminant"
                                description="Vols eliminar definitivament aquest element?"
                                onConfirm={() => deleteElement(ele)}
                                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            >
                                <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                            </Popconfirm>
                    )}{" "}

                    {/* VEURE */}
                    {potVeure && ele.estat !== 3 && ele.estat !== 0 &&(
                    <Button
                        title="Veure"
                        style={{ backgroundColor: Colors.colors.color4 }}
                        onClick={() => togleEditar(ele.id, true)} 
                    >
                        <BsEye />
                    </Button>
                    )}{" "}

                    {/* DESCARREGAR PDF */}
                    <Button
                        title="Descarregar PDF"
                        style={{ backgroundColor: Colors.colors.color1, color: '#fff' }}
                        onClick={() => descarregarPdf(ele)}
                    >
                        <BsFilePdf />
                    </Button>{" "}

                    {/* ESTAT 3 (Comanda finalitzada) */}
                    {ele.estat === 3 && (
                    <>
                        {permisEditarComanda ? (
                        <>
                            <Button
                            title="Veure Comanda Finalitzada"
                            style={{ backgroundColor: Colors.colors.color3 }}
                            onClick={() => togleVeuComandaFinalizada(ele)}
                            >
                            <BsReceipt />
                            </Button>{" "}
                            <Popconfirm
                                title="Revertir"
                                description="Un cop revertida, s'eliminaran els ingredients de la comanda. ¿Estàs segur?"
                                onConfirm={() => revertirElement(ele)}
                                icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                                >
                                <Button
                                    title="Revertir"
                                    style={{
                                    backgroundColor: Colors.colors.color2,
                                    color: Colors.colors.color6,
                                    }}
                                >
                                    <BiUndo />
                                </Button>
                            </Popconfirm>
                        </>
                        ) : (
                        // Sin permisos: no puede hacer nada
                        <></>
                        )}
                    </>
                    )}
                </>
                );
            },
            }

    ];

    // Retorna la setmana ISO d'una data en format "YYYY-Www" (com l'input week).
    function setmanaISO(d: Date): string {
        const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
        const dayNum = date.getUTCDay() || 7;
        date.setUTCDate(date.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
        const weekNo = Math.ceil((((date.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
        return `${date.getUTCFullYear()}-W${String(weekNo).padStart(2, '0')}`;
    }

    // Dades filtrades opcionalment per setmana (client-side).
    const dadesFiltrades = setmana
        ? coleccio.filter(p => p.inici && setmanaISO(new Date(p.inici)) === setmana)
        : coleccio;

    const tableProps: TableProps<Proposta> = {
        loading
    };

    const onChange: TableProps<Proposta>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
    };


    async function handleChange(value: number[]) {
        if (value.length !== 0) {
            console.log(value);
            await setFiltres(value);
            await checkDades(value);
        } else {
            setDades([]);
        }
    }

    type TagRender = SelectProps['tagRender'];
    const tagRender: TagRender = (props) => {
        const {label, value, closable, onClose} = props;
        const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
            event.preventDefault();
            event.stopPropagation();
        };
        const colors = ["orange", "blue", "cyan", "green"];
        return (
            <Tag
                color={colors[value]}
                onMouseDown={onPreventMouseDown}
                closable={closable}
                onClose={onClose}
                style={{marginRight: 3}}
            >
                {label}
            </Tag>
        );
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"} style={{alignItems: "center", display: "flex"}}>
                            { permisEditarProposta &&
                                <Button title={"Crear"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(new Proposta())}><BiPlus/></Button>
                            }
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades(filtres)}><BiRefresh/></Button>
                            <div>{" "}
                                <Select
                                    mode="multiple"
                                    allowClear
                                    disabled={!permisEditarComanda}
                                    tagRender={tagRender}
                                    style={{width: '400px', flexGrow: 1}}
                                    placeholder="Please select"
                                    value={filtres}
                                    onChange={handleChange}
                                    options={options}
                                />
                            </div>
                            <div style={{marginLeft: 8, display: 'flex', alignItems: 'center', gap: 6}}>
                                <span>Setmana:</span>
                                <input
                                    type="week"
                                    value={setmana}
                                    onChange={(e) => setSetmana(e.target.value)}
                                    style={{height: 32, borderRadius: 6, border: '1px solid #d9d9d9', padding: '0 8px'}}
                                />
                                {setmana && (
                                    <Button size="small" onClick={() => setSetmana("")}>Netejar</Button>
                                )}
                            </div>
                        </div>
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                pagination={{pageSize: 100}}
                                dataSource={dadesFiltrades}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"PROPOSTA"} pagina={page}/>
                    {nouElement && (
                        <PopostesModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar}/>
                    )}
                    {nouElementFinalizat && (
                        <ComandaFinalizadaModal element={elementSelected.id+""} onClose={handleCloseModalFinalizat} visible={nouElementFinalizat}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Propostes;
